import React from "react";

import { Header } from "../components/componentHeader/Header";
import { Nav } from "../components/componentNav/Nav";
import { Target } from "../components/componentTarget/Target";
import { Infoview } from "../components/componentBody/Infoview";
import { Video } from "../components/componentVideo/Video";
import { Audio } from "../components/componentAudio/Audio";
import { Table } from "../components/componentTable/Table";
import { Contact } from "../components/componentContat/Contact";
import { Footer } from "../components/componentFooter/Footer";
import { TaskSeo } from '../context/TaskSeo'
import { TaskSeoNav } from '../context/TaskSeoNav'
import { TaskSeoArticle } from '../context/TaskSeoArticle'

export function Home() {
  window.scrollTo(0,0);
  return (
    <>
    <TaskSeo />
    <TaskSeoNav />
    <TaskSeoArticle/>
    <Header />
    <Nav />
    <Target />
    <Infoview />
    <Video /><Audio />
    <Table />
    <Contact />
    <Footer /></>
  );
}
